module.exports = [
	{
		"rank": "boston-celtics"
	},
	{
		"rank": "chicago-bulls"
	},
	{
		"rank": "golden-state-warriors"
	},
	{
		"rank": "los-angeles-lakers"
	},
	{
		"rank": "memphis-grizzlies"
	},
	{
		"rank": "minnesota-timberwolves"
	},
	{
		"rank": "orland-magic"
	},
	{
		"rank": "san-antonio-spurs"
	},
	{
		"rank": "toronto-raptors"
	}
];


//////////////////
// WEBPACK FOOTER
// ../server/cards.json
// module id = 241
// module chunks = 0